module.exports = __webpack_public_path__ + "img/C07TechAxemanChampion_ua.71c9a975.webp";